import { track } from "../track";

export const trackAvatarPhotoUploadFail = (params: { error: string }) =>
  track({ event: "avatar_photo_upload_fail", ...params });
